import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer id="contato" className="bg-primary relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-12 sm:py-20">
        <div className="grid lg:grid-cols-12 gap-8 sm:gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2 mb-6 sm:mb-8">
              <img 
                src="https://static.readdy.ai/image/c30d1200a69d27266a785c8d79b381ff/57e5611cc65ba6dce761df2e05562b72.png" 
                alt="Criarquitetura"
                className="h-16 sm:h-20 w-auto brightness-0 invert"
              />
            </div>

            <form className="mb-8 sm:mb-10">
              <div className="flex items-center gap-2">
                <input
                  type="email"
                  placeholder="Seu e-mail"
                  className="flex-1 px-4 sm:px-6 py-2.5 sm:py-3 bg-transparent border-2 border-white/40 rounded-full text-white placeholder-white/60 font-inter text-sm focus:outline-none focus:border-white/80 transition-colors"
                />
                <button
                  type="submit"
                  className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-accent rounded-full hover:bg-accent/90 transition-colors cursor-pointer flex-shrink-0"
                >
                  <i className="ri-send-plane-fill text-white text-base sm:text-lg"></i>
                </button>
              </div>
            </form>

            <h3 className="font-playfair text-2xl sm:text-3xl text-white leading-relaxed">
              Arquitetura que valoriza<br />a paisagem litorânea
            </h3>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            <div>
              <h4 className="font-inter font-semibold text-sm sm:text-base text-white mb-4 sm:mb-6">Serviços</h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <Link to="/servicos" className="font-inter text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    Projetos Residenciais
                  </Link>
                </li>
                <li>
                  <Link to="/servicos" className="font-inter text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    Arquitetura Litorânea
                  </Link>
                </li>
                <li>
                  <Link to="/servicos" className="font-inter text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    Acompanhamento
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-inter font-semibold text-sm sm:text-base text-white mb-4 sm:mb-6">Projetos</h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <a href="#projetos" className="font-inter text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    Casas de Praia
                  </a>
                </li>
                <li>
                  <a href="#projetos" className="font-inter text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    Terrenos Inclinados
                  </a>
                </li>
                <li>
                  <a href="#projetos" className="font-inter text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    Portfólio Completo
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-inter font-semibold text-sm sm:text-base text-white mb-4 sm:mb-6">Estúdio</h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <Link to="/sobre" className="font-inter text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    Sobre
                  </Link>
                </li>
                <li>
                  <a href="#metodo" className="font-inter text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    Método
                  </a>
                </li>
                <li>
                  <a href="#contato" className="font-inter text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    Contato
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-inter font-semibold text-sm sm:text-base text-white mb-4 sm:mb-6">Contato</h4>
              <ul className="space-y-2 sm:space-y-3">
                <li className="font-inter text-xs sm:text-sm text-white/80">
                  <i className="ri-phone-line mr-2"></i>
                  (12) 97403-4577
                </li>
                <li className="font-inter text-xs sm:text-sm text-white/80 break-all">
                  <i className="ri-mail-line mr-2"></i>
                  criarquitetura@hotmail.com
                </li>
                <li className="font-inter text-xs sm:text-sm text-white/80">
                  <i className="ri-map-pin-line mr-2"></i>
                  Ilhabela, SP
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/10 bg-[#0A2020]">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-4 sm:py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
            <p className="font-inter text-xs text-white/60 text-center md:text-left">
              © 2025 Criarquitetura. Todos os direitos reservados.
            </p>

            <div className="flex items-center gap-3 sm:gap-4">
              <a
                href="https://instagram.com/criarquiteturailha"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center border border-white/40 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-white text-base sm:text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center border border-white/40 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-line text-white text-base sm:text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center border border-white/40 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-line text-white text-base sm:text-lg"></i>
              </a>
              <a
                href="https://wa.me/5512974034577"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center border border-white/40 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-white text-base sm:text-lg"></i>
              </a>
            </div>

            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="font-inter text-xs text-white/60 hover:text-white/80 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
